import React, { Component } from 'react'

class TextAreaProps {
    name?: string;
    value?: string;
    label?: string;
    errorMessage?: string;
    rows?: number;
    placeholder?: string;
    disabled?: boolean;
    onChange?: (value: string, name?: string) => void;
}

class TextAreaState { }

class TextArea extends Component<TextAreaProps, TextAreaState> {

    private handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (this.props.onChange) {
            this.props.onChange(e.target.value, this.props.name);
        }
    }

    render() {
        const name = this.props.name || '';
        const value = this.props.value || '';
        const placeholder = this.props.placeholder || '';
        const disabled = !!this.props.disabled;
        const rows = this.props.rows || 5;
        const id = Math.random().toString(36).substring(2);
        let label = <></>;

        if (this.props.label) {
            label = <label htmlFor={id} className={"label" + (this.props.errorMessage ? " is-danger" : "")}>{this.props.label}</label>;
        }

        return (
            <div className="field">
                {label}
                <div className="control">
                    <textarea className={"textarea" + (this.props.errorMessage ? " is-danger" : "")}
                        id={id}
                        name={name}
                        placeholder={placeholder}
                        disabled={disabled}
                        value={value}
                        rows={rows}
                        onChange={this.handleInputChange} />
                </div>
                {
                    this.props.errorMessage && <p className="help is-danger">{this.props.errorMessage}</p>
                }
            </div>
        );
    }
}

export default TextArea;
